import { TFunction } from 'i18next';
import { string } from 'yup';

export const urlValidation = (t: TFunction) =>
  string().test('url-format', t('url.format'), function (value) {
    if (!value || value.trim() === '') return true;
    return value.startsWith('https://');
  });
